// Helper functions for currency formatting and conversion
export const formatPrice = (price, currency, exchangeRate = 1) => {
  if (!price) return '0.00';
  
  const usdPrice = parseFloat(price);
  const localPrice = usdPrice * parseFloat(exchangeRate);
  
  if (currency === 'LBP') {
    return `$${usdPrice.toFixed(2)} / ${localPrice.toFixed(0)} ل.ل`;
  }
  
  return `$${usdPrice.toFixed(2)}`;
};

export const getCurrencySymbol = (currency) => {
  const symbols = {
    USD: '$',
    LBP: 'ل.ل',
    EUR: '€',
    GBP: '£',
    JPY: '¥'
  };
  return symbols[currency] || '$';
};

export const formatLocalPrice = (price, currency, exchangeRate = 1) => {
  if (!price) return '0.00';
  
  const usdPrice = parseFloat(price);
  const localPrice = usdPrice * parseFloat(exchangeRate);
  
  if (currency === 'LBP') {
    return `${localPrice.toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ",")} ${getCurrencySymbol(currency)}`;
  }
  
  return `${getCurrencySymbol(currency)}${localPrice.toFixed(2)}`;
};
